import { FormControl, FormLabel, styled } from "@mui/material";
import { TextField as FormikTextField, TextFieldProps } from "formik-mui";

export function TextField(props: TextFieldProps) {
  const { label, fullWidth, className, ...formProps } = props;

  return (
    <StyledFormControl fullWidth={fullWidth} className={className}>
      <FormLabel>{label}</FormLabel>
      <FormikTextField fullWidth={fullWidth} {...formProps} />
    </StyledFormControl>
  );
}
const StyledFormControl = styled(FormControl)`
  .MuiInputBase-root {
    background-color: ${({ theme }) => theme.palette.common.black};
  }
`;
